export const isUserAdmin = (user) => user?.roles?.indexOf("admin") !== -1